import { Button, Checkbox, Modal } from "flowbite-react";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useAppSelector } from "../../Reducers/store";
import { Delivery } from "../../Models/Delivery";
import Loader from "../Common/Loader";
import DeliveryApi from "../../Api/DeliveryApi";
import AssetApi from "../../Api/AssetApi";

export default function SOPForm({
  show,
  setShow,
  selectedDelivery,
  deliverySubmitComplete,
  assetId,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  selectedDelivery: Delivery | null;
  deliverySubmitComplete: () => void;
  assetId: number;
}) {
  const { userModel } = useAppSelector((state) => state.user);
  const { clientsWithLocation } = useAppSelector((state) => state.commonFields);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const [formData, setFormData] = useState<Delivery>({
    id: 0,
    clientLocationId: null,
    jobId: null,
    deliveredBy: null,
    dateDelivered: null,
    signature: null,
    startTime: null,
    endTime: null,
    inMileage: null,
    outMileage: null,
    acceptedBy: null,
    statusId: null,
    quickBooksId: null,
    notes: null,
    clientId: null,
    clientContactId: null,

    client: null,
    clientLocation: null,
    deliveryItems: [],
    status: null,
    deliveryAssets: [],
  });

  const handleSetInitialValues = () => {
    const values = selectedDelivery
      ? {
          ...selectedDelivery,
        }
      : {
          id: 0,
          clientLocationId: null,
          jobId: null,
          deliveredBy: null,
          dateDelivered: null,
          signature: null,
          startTime: null,
          endTime: null,
          inMileage: null,
          outMileage: null,
          acceptedBy: null,
          statusId: null,
          quickBooksId: null,
          notes: null,
          clientId: null,
          clientContactId: null,

          client: null,
          clientLocation: null,
          deliveryItems: [],
          status: null,
          deliveryAssets: [],
        };
    setFormData(values as Delivery);
  };

  useEffect(() => {
    if (clientsWithLocation) {
      handleSetInitialValues();
    }
  }, [selectedDelivery]);

  const handleResetFormValues = () => {
    const values = {
      id: 0,
      clientLocationId: null,
      jobId: null,
      deliveredBy: null,
      dateDelivered: null,
      signature: null,
      startTime: null,
      endTime: null,
      inMileage: null,
      outMileage: null,
      acceptedBy: null,
      statusId: null,
      quickBooksId: null,
      notes: null,
      clientId: null,
      clientContactId: null,

      client: null,
      clientLocation: null,
      deliveryItems: [],
      status: null,
      deliveryAssets: [],
    };
    setFormData(values as Delivery);
    setButtonDisabled(false);
  };

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    setButtonDisabled(true);
    setIsLoading(true);
    formData.deliveredBy = userModel?.id ?? null;

    // Ensure startTime and endTime are sent with explicit timezone offset
    if (formData.startTime) {
      // Convert to local datetime with timezone offset
      const date = new Date(formData.startTime);
      const pad = (n: number) => String(n).padStart(2, "0");

      // Get timezone offset in minutes and convert to HH:MM format
      const offsetMinutes = date.getTimezoneOffset();
      const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
      const offsetMins = Math.abs(offsetMinutes) % 60;
      const offsetSign = offsetMinutes <= 0 ? "+" : "-";
      const timezoneOffset = `${offsetSign}${pad(offsetHours)}:${pad(
        offsetMins
      )}`;

      // Create ISO string with timezone offset
      formData.startTime = `${date.getFullYear()}-${pad(
        date.getMonth() + 1
      )}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(
        date.getMinutes()
      )}:00${timezoneOffset}`;
      console.log(
        "SOPForm sending startTime with timezone offset:",
        formData.startTime
      );
    }

    if (formData.endTime) {
      // Convert to local datetime with timezone offset
      const date = new Date(formData.endTime);
      const pad = (n: number) => String(n).padStart(2, "0");

      // Get timezone offset in minutes and convert to HH:MM format
      const offsetMinutes = date.getTimezoneOffset();
      const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
      const offsetMins = Math.abs(offsetMinutes) % 60;
      const offsetSign = offsetMinutes <= 0 ? "+" : "-";
      const timezoneOffset = `${offsetSign}${pad(offsetHours)}:${pad(
        offsetMins
      )}`;

      // Create ISO string with timezone offset
      formData.endTime = `${date.getFullYear()}-${pad(
        date.getMonth() + 1
      )}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(
        date.getMinutes()
      )}:00${timezoneOffset}`;
      console.log(
        "SOPForm sending endTime with timezone offset:",
        formData.endTime
      );
    }

    let deliveryUpdated = false;
    let assetQuantityUpdated = false;
    try {
      const res = await DeliveryApi.submitDelivery(formData);
      if (res) {
        if (res.data.success === false) {
          deliveryUpdated = false;
          toast.error(res.data.message);
        } else {
          deliveryUpdated = true;
          if (selectedDelivery && assetId > 0) {
            const updateRes = await AssetApi.updateAssetQuantities(
              assetId,
              selectedDelivery.id
            );
            if (updateRes) {
              if (updateRes.data.success === false) {
                assetQuantityUpdated = false;
                toast.error(res.data.message);
              } else {
                assetQuantityUpdated = true;
              }
            }
          }
          setIsLoading(false);
          setButtonDisabled(false);
          if (deliveryUpdated && assetQuantityUpdated) {
            toast.success("Save Success");
            onCloseModal();
            deliverySubmitComplete();
          } else {
            toast.error("Error While Saving");
          }
        }
      } else toast.error("Error: Bad response from server");
    } catch (err) {
      toast.error("Error: " + err);
    }
  };

  function onCloseModal() {
    handleResetFormValues();
    setShow(false);
  }

  return (
    <>
      <Modal show={show} size="xl" onClose={onCloseModal} popup>
        <Modal.Header>Submit Drop Ticket</Modal.Header>
        <Modal.Body>
          <div className="relative">
            {isLoading && <Loader />}
            <div className="w-full">
              {/* <div className='w-full'>
              <div className='mx-1 flex items-end justify-center'>
                <div className='flex flex-1 justify-center'>
                  <h1 className='text-gray-900 font-bold text-4xl'>Delivery</h1>
                </div>
              </div>
            </div> */}
              <div>
                <div className="container mx-auto p-2">
                  <div className="md:flex no-wrap md:-mx-2 ">
                    <div className="w-full">
                      <div className="bg-white">
                        <form id="dropTicketForm" onSubmit={onSubmit}>
                          <div className="text-black">
                            <div className="flex mb-2 mx-2"></div>
                            <div className="w-full">
                              <i></i>
                            </div>
                            <div className="flex">
                              <div className=" ml-2 mr-5">
                                <Checkbox
                                  id="returnRequired"
                                  name="returnRequired"
                                  // onChange={handleChangeCheckboxInputParts}
                                  // checked={formData.returnRequired ?? false}
                                  required
                                />
                              </div>
                              <div>
                                <div className="content-center">
                                  I wore the proper PPE onsite at all times.
                                </div>
                              </div>
                            </div>
                            <div className="flex">
                              <div className=" ml-2 mr-5">
                                <Checkbox
                                  id="returnRequired"
                                  name="returnRequired"
                                  // onChange={handleChangeCheckboxInputParts}
                                  // checked={formData.returnRequired ?? false}
                                  required
                                />
                              </div>
                              <div>
                                <div className="content-center">
                                  I turned off the gas to the trailer pump motor
                                  after use.
                                </div>
                              </div>
                            </div>
                            <div className="flex">
                              <div className=" ml-2 mr-5">
                                <Checkbox
                                  id="returnRequired"
                                  name="returnRequired"
                                  // onChange={handleChangeCheckboxInputParts}
                                  // checked={formData.returnRequired ?? false}
                                  required
                                />
                              </div>
                              <div>
                                <div className="content-center">
                                  I locked pump trailer door after use.
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="flex justify-end pt-2">
                            <Button
                              disabled={buttonDisabled}
                              type="submit"
                              className="buttonMain"
                              form="dropTicketForm"
                              // onClick={() => onSubmit()}
                            >
                              Submit
                            </Button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
